import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER, api } from "../../lib/api";

export default function FloatingWhatsApp() {
  const [num, setNum] = useState(WHATSAPP_NUMBER);
  useEffect(() => {
    api.get("/settings/public").then(({ data }) => {
      if (data?.whatsapp_number) setNum(data.whatsapp_number.replace(/[^0-9]/g, ""));
    }).catch(() => {});
  }, []);
  const href = `https://wa.me/${num}?text=Hi%20Next%20Gen%20Praise%20NPC%2C%20I%27d%20like%20to%20get%20in%20touch.`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1da851] text-white rounded-full shadow-lg transition-all px-4 py-3"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-button"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm font-medium">WhatsApp</span>
    </a>
  );
}
